import type { ReactNode } from 'react';
import { AgxPanel, AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import { tokens } from '@urbanx/agx.ui-components2/tokens';
import './SettingsSection.scss';

interface Props {
  id: string;
  title: string;
  description: string;
  applicability?: string;
  ariaLabel?: string;
  children: ReactNode;
}

export default function SettingsSection({
  id,
  title,
  description,
  applicability,
  ariaLabel,
  children,
}: Props) {
  return (
    <AgxPanel
      id={`${id}-section`}
      variant="section"
      className="agx-settings-section"
      role="region"
      aria-label={ariaLabel}
      aria-labelledby={ariaLabel ? undefined : `${id}-title`}
      header={
        <AgxSpacer gap="spacing-xs">
          <AgxSpacer
            direction="horizontal"
            contentJustification="space-between"
            contentAlignment="center"
            gap="spacing-lg"
            wrap
          >
            <AgxTypography
              id={`${id}-title`}
              type="label"
              size="large"
              role="heading"
              aria-level={2}
            >
              {title}
            </AgxTypography>
            {applicability && (
              <AgxTypography type="caption" size="small" color={tokens.text.secondary}>
                {applicability}
              </AgxTypography>
            )}
          </AgxSpacer>
          <AgxTypography type="body_ui" size="small" color={tokens.text.secondary}>
            {description}
          </AgxTypography>
        </AgxSpacer>
      }
    >
      {children}
    </AgxPanel>
  );
}
